<template>
  <div>
    <van-tree-select
      v-model:active-id="activeId"
      v-model:main-active-index="activeIndex"
      height="94vh"
      :items="mealList"
      @click-nav="rightClick"
    >
      <template #content>
        <van-index-bar
          :index-list="indexList"
          index="主食"
          @change="indexBarChange"
        >
          <van-row
            v-for="item in mealList"
            :key="item.id"
            align="center"
            style="padding: 10px"
          >
            <van-index-anchor
              style="width: 100%; background: #f7f8fa"
              :id="item.name"
              :index="item.name"
            ></van-index-anchor>
            <!-- <van-row
              style="
                padding: 15px;
                background: #f7f8fa;
                color: #999;
                width: 100%;
              "
            >
              {{ item.name }}
            </van-row> -->
            <van-row
              v-for="meal in item.businessDishes"
              :key="meal.id"
              align="center"
              style="padding: 10px; width: 100%"
            >
              <van-col span="4" @click="toMealsDetails(meal)">
                <van-image :src="meal.headUrl" />
              </van-col>
              <van-col
                span="14"
                @click="toMealsDetails(meal)"
                style="padding-left: 10px"
              >
                <p style="padding: 5px 0">{{ meal.name }}</p>
                <p style="padding: 5px 0">
                  <span style="color: #1e98d7"> ￥{{ meal.price }} </span>
                  <span style="color: #999">/{{ meal.unitName }}</span>
                </p>
              </van-col>
              <van-col span="6">
                <van-stepper
                  @change="stepperChange(meal)"
                  v-model="meal.quantity"
                  input-width="20"
                  theme="round"
                  button-size="15"
                  disable-input
                  :default-value="0"
                  :min="0"
                />
              </van-col>
            </van-row>
          </van-row>
        </van-index-bar>
      </template>
    </van-tree-select>
    <!-- 购物车bar -->
    <ShoppingCart
      @cartEmpty="cartEmpty"
      :shoppingData="shoppingData"
    ></ShoppingCart>
  </div>
</template>
<script setup>
import { requestMealList } from "@/api/orderingFood/orderingFood";
import { reactive, toRefs, computed } from "vue";
import { arrGoAgain } from "@/utils/common";
import { useRoute, useRouter } from "vue-router";
import ShoppingCart from "@/components/orderingFood/shoppingCart.vue";
import { setStorage, getStorage } from "@/utils/common";
const route = useRoute();
const router = useRouter();
const state = reactive({
  canteenId: route.query.canteenId,
  mealList: [],
  activeId: null,
  activeIndex: 0,
  mealObj: {},
  shoppingData: {
    selectList: [],
    shoppingCarNum: 0,
    mealTypeName: "",
    mealTypeType: "",
    orgId: route.query.orgId,
    canteenId: route.query.canteenId,
    orgAddress: route.query.orgAddress,
    orderType: 2,
  },
  indexList: [],
});
// 修改浏览器title
window.document.title = `今日${route.query.orderMeal}`;
const {
  mealList,
  activeId,
  activeIndex,
  mealObj,
  testNum,
  selectList,
  shoppingCarNum,
  shoppingData,
  indexList,
} = toRefs(state);
// 初始化数据
setStorage("shoppingData", JSON.stringify(state.shoppingData));
const queryMealList = () => {
  requestMealList({ canteenId: state.canteenId }).then((v) => {
    const { data } = v;
    const indexList = [];
    data.businessDishTypes.forEach((value) => {
      indexList.push(value.name);
      value.businessDishes.forEach((food) => {
        food.text = food.name;
      });
      value.text = value.name;
      value.children = value.businessDishes;
    });
    state.mealList = data.businessDishTypes;
    state.mealObj = data.businessDishTypes[0];
    state.indexList = indexList;
    state.shoppingData.mealTypeName = data.mealTypeName;
    state.shoppingData.mealType = data.mealType;
  });
};
queryMealList();
// 点击右侧
const rightClick = (val) => {
  const mealObj = state.mealList.filter((item, index) => {
    return index == val;
  })[0];
  state.mealObj = mealObj;
  const element = document.getElementById(mealObj.name);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
  console.log(element);
  window.location.href = `#${mealObj.name}`;
};
// 加减号
const stepperChange = (val) => {
  if (val.quantity > 0) {
    state.shoppingData.selectList.push(val);
  } else {
    console.log(val.quantity);
    state.shoppingData.selectList.forEach((value, index) => {
      if (value.id == val.id) {
        state.shoppingData.selectList.splice(index, 1);
      }
    });
  }
  state.shoppingData.selectList = arrGoAgain(state.shoppingData.selectList);
  setStorage("shoppingData", JSON.stringify(state.shoppingData));
};
// 购物车数量
state.shoppingData.shoppingCarNum = computed(() => {
  let cartNum = 0;
  state.shoppingData.selectList.forEach((value) => {
    cartNum += value.quantity;
  });
  return cartNum;
});
// 购物车清空
const cartEmpty = () => {
  state.mealList.forEach((value) => {
    value.businessDishes.forEach((food) => {
      food.quantity = 0;
    });
  });

  console.log(132132);
};
const indexBarChange = (val) => {
  state.mealList.forEach((value, index) => {
    if (value.name == val) {
      state.activeIndex = index;
    }
  });
};
const toMealsDetails = (item) => {
  console.log(132123);
  router.push({ name: "mealsDetails", query: { id: item.id } });
};
</script>
<style lang="scss" scoped>
.van-icon-shopping-cart {
  font-size: 40px;
}
::v-deep .van-submit-bar__text {
  text-align: left;
  padding-left: 15px;
  span {
    color: #1e98d7;
  }
}
::v-deep .van-index-bar__sidebar {
  display: none;
}
</style>
